export default {
  lastSevenDays: 'lastSevenDays',
  thisWeek: 'thisWeek',
  lastWeek: 'lastWeek',
  lastThirtyDays: 'lastThirtyDays',
  thisMonth: 'thisMonth',
  lastMonth: 'lastMonth',
  custom: 'custom',
};
